import React from 'react';
import { Radio } from 'antd';
import classNames from 'classnames';

const SelectGroup = ({ children, value, onChange }) => {
  return (
    <div className="select-list__group">
      {React.Children.map(children, child =>
        React.cloneElement(child, {
          selected: value === child.props.name,
          onChange,
        }),
      )}
    </div>
  );
};

const SelectItem = ({
  name,
  label,
  des,
  icon,
  selected,
  onChange,
  renderSetting,
  renderExtraInfo,
}) => {
  const [setting, setSetting] = React.useState();
  return (
    <div
      className={classNames('select-list__item', {
        'select-list__item--selected': selected,
      })}
    >
      <div className={classNames('select-list__item__main')} onClick={() => onChange(name)}>
        <div className="select-list__item__left">
          {icon && <div className="select-list__item__svg">{icon}</div>}

          <div className="select-list__item__text">
            <h4>{label}</h4>
            <p>{des}</p>
            {renderExtraInfo && (
              <div className="select-list__item__extra-info">{renderExtraInfo}</div>
            )}
          </div>
        </div>

        <Radio checked={selected} />
      </div>

      {renderSetting && selected && (
        <div className="select-list__item__setting">{renderSetting(setting, setSetting)}</div>
      )}
    </div>
  );
};

const ButtonList = ({ options, value, onChange, buttonSameSize, ref }) => {
  return (
    <div className="select-list__button-list" ref={ref}>
      {options.map(option => (
        <button
          key={option.value}
          className={classNames('select-list__button-list__button', {
            'select-list__button-list__button--selected': option.value === value,
            'select-list__button-list__button--same-size': buttonSameSize,
          })}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

const SelectList = {
  Group: SelectGroup,
  Item: SelectItem,
  ButtonList: React.forwardRef(ButtonList),
};

export default SelectList;
